import React, {useEffect, useState} from "react";
import {JobDefinition} from "./JobDefinition";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {Breadcrumbs, CircularProgress, Grid, IconButton, Link, Typography} from "@mui/material";
import {GET_JOB_DEFINITIONS} from "../graphql/queries/gqlGetJobDefinitions";
import {IJobDefinition} from "../../models/JobDefinition";
import AddIcon from "@mui/icons-material/Add";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";

export const JobDefinitions: React.FC = (props) => {
	const favouritesKey = "surebase-querytool-job_definitions-favourites";
	const [data, setData] = useState<IJobDefinition[]>([]);
	const [submitLoading, setSubmitLoading] = useState<boolean>(false);
	const [favourites, setFavourites] = useState<number[]>(JSON.parse(window.localStorage.getItem(favouritesKey) ?? "[]"));
	const navigate = useNavigate();
	const fetch = async () => {
		setSubmitLoading(true);
		await graphQLServices.querytoolClient.query({
			query: GET_JOB_DEFINITIONS,
			variables: {where: {}, order: {}},
		})
			.catch((reason) => toast.error("Unable to get definitions:"))
			.then((result: any) => {
				setData(result?.data?.jobDefinitions?.nodes ?? []);
				setSubmitLoading(false);
			});
		
		
	};
	
	const toggleItemInFavourites = (id: number) => {
		if (favourites.filter(it => it === id).length > 0) {
			setFavourites(favourites.filter(it => it !== id));
		} else {
			setFavourites([...favourites, id]);
		}
	};
	
	const addButton = (): React.ReactNode => {
		return (
			<IconButton onClick={() => navigate("/querytool/jobdefinitions/modify")}>
				<AddIcon />
			</IconButton>
		);
	};
	
	useEffect(() => {
		//ts-ignore
		fetch();
	}, []);
	
	useEffect(() => {
		window.localStorage.setItem(favouritesKey, JSON.stringify(favourites));
	}, [favourites]);
	
	return (
		
		<div>


			<Breadcrumbs aria-label="breadcrumb">
				<Link underline="hover" color="inherit" href="/querytool/jobdefinitions">
					QueryTool
				</Link>
				<Typography color="text.primary">Job Definitions</Typography>
			</Breadcrumbs>
			{submitLoading && <CircularProgress />}
			{!submitLoading && addButton()}
			{!submitLoading &&
			<Grid container spacing={2}>
				{/*eslint-disable-next-line*/}
				{data.map((job) => {
					if (favourites.includes(job.id)) {
						return (
							<JobDefinition key={`job_definitions-job_definition-${job.id}`} id={job.id} name={job.name} description={job.description} stepsCount={job.jobSteps.length}
								favourite={favourites.includes(job.id)} setFavourite={toggleItemInFavourites}/>
						);
					}
				})}
				{/*eslint-disable-next-line*/}
				{data.map(job => {
					if (!favourites.includes(job.id)) {
						return (
							<JobDefinition key={`job_definitions-job_definition-${job.id}`} id={job.id} name={job.name} description={job.description} stepsCount={job.jobSteps.length}
								favourite={favourites.includes(job.id)} setFavourite={toggleItemInFavourites}/>
						);
					}
				})}
			</Grid>
			}
		</div>
	);
};
